import React, { useEffect, useState } from 'react';
import { ArrowRight, Eye } from 'lucide-react';  // 👈 added Eye

const houseImages = [
  {
    url: "/assets/images/house2.webp",
    caption: "Modern House Rebuilding"
  },
  {
    url: "/assets/images/paint 2.webp",
    caption: "Elegant House Painting"
  },
  {
    url: "/assets/images/pop4.jpg",
    caption: "Pop House Aesthetics"
  },
  {
    url: " /assets/images/cr house.jpg ",
    caption: "Creative Home Renovation"
  }
];

const Hero = () => {
  const [imgIndex, setImgIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setImgIndex((prev) => (prev + 1) % houseImages.length);
        setFade(true);
      }, 600);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero-split">
      <div className="hero-left">
        <h1>
          WELCOME TO <br /> ZIRAE CHEMICALS
        </h1>
        <p>
          We specialize in <strong>house rebuilding</strong>, <strong>painting</strong>, and <strong>aesthetic upgrades</strong>.<br />
          Let Zirae Chemicals bring your dream home to life with modern design, quality materials, and expert craftsmanship.
        </p>
        <div className="two">
          <a href="#contact" className="cta-btn">Start Your Project</a>
          <a href="#contact" className="cta-btn2">
            <Eye className="inline-block mr-2 w-5 h-5" /> {/* 👈 Eye icon */}
            View Our Work
          </a>
        </div>
      </div>

      <div className="hero-right">
        <div className={`hero-slider${fade ? ' fade-in' : ' fade-out'}`}>
          <img
            src={houseImages[imgIndex].url}
            alt={houseImages[imgIndex].caption}
            className="hero-img"
          />
          <div className="hero-caption">{houseImages[imgIndex].caption}</div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
